// src/pages/specialx/RegisterListSpecialX.jsx
import { useEffect, useState } from "react";
import { fetchSheetViaProxy } from "../../lib/sheets";

const SHEET_ID = "1bdWoKQm-B96F6fGmeB7Lo0BAiKDglXsQboXaVdtkIZI";
const RANGE = "Anmeldungen!A1:E200";

export default function RegisterListSpecialX() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;

        async function load() {
            try {
                setLoading(true);
                setError("");

                const { rows: raw } = await fetchSheetViaProxy({
                    sheetId: SHEET_ID,
                    range: RANGE,
                });

                const sample = raw[0] || {};
                const keys = Object.keys(sample);

                const tsKey =
                    keys.find((k) => k.toLowerCase().includes("zeitstempel")) ||
                    keys.find((k) => k.toLowerCase().includes("timestamp")) ||
                    "Zeitstempel";

                const cleaned = raw.map((r, idx) => {
                    const fullName = (r["Vor- und Nachname"] || "").trim();

                    const upperValues = Object.values(r || {}).map((v) =>
                        String(v ?? "").toUpperCase()
                    );

                    const isWaitlistSep =
                        !fullName && upperValues.some((val) => val.includes("WARTELISTE"));

                    return {
                        id: r["ID"] || String(idx + 1),
                        ts: r[tsKey] || "",
                        fullName,
                        iracingName: r["iRacing Name"] || "",
                        iracingId: r["iRacing ID"] || "",
                        isWaitlistSep,
                    };
                });

                const onlyWithName = cleaned.filter(
                    (r) => r.isWaitlistSep || (r.fullName && r.fullName.trim() !== "")
                );

                if (!cancelled) {
                    setRows(onlyWithName);
                }
            } catch (err) {
                console.error(err);
                if (!cancelled) {
                    setError(
                        err instanceof Error ? err.message : "Unbekannter Fehler beim Laden."
                    );
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        load();
        return () => {
            cancelled = true;
        };
    }, []);

    if (loading) {
        return (
            <div className="card card--accent">
                <h1>Anmeldeliste – Special Xperience</h1>
                <p>Die Anmeldungen werden geladen…</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="card card--accent">
                <h1>Anmeldeliste – Special Xperience</h1>
                <p>Fehler beim Laden der Anmeldungen:</p>
                <p style={{ color: "#ff6b6b" }}>{error}</p>
            </div>
        );
    }

    return (
        <div className="card card--accent">
            <h1>Anmeldeliste – Special Xperience</h1>
            <p style={{ marginBottom: "20px" }}>
                Hier siehst du die aktuell angemeldeten Fahrer der Special Xperience.
                <br />
            </p>

            <div className="fancyTable regTable-wrapper">
                <table className="tbl regTable">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Zeitstempel</th>
                        <th className="align-left">Vor- und Nachname</th>
                        <th className="align-left">iRacing Name</th>
                        <th>iRacing ID</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rows.map((r, idx) => {
                        if (r.isWaitlistSep) {
                            return (
                                <tr key={`waitlist-${idx}`}>
                                    <td colSpan="5" style={{ fontWeight: 700 }}>
                                        WARTELISTE
                                    </td>
                                </tr>
                            );
                        }

                        return (
                            <tr key={`${r.id}-${idx}`}>
                                <td>{r.id}</td>
                                <td>{r.ts}</td>
                                <td className="align-left">{r.fullName}</td>
                                <td className="align-left">{r.iracingName}</td>
                                <td>{r.iracingId}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}